import onDomReady from '../onDomReady';

export default class FilterDropdown {
	constructor() {
		this.initialize();
	}

	initialize() {
		onDomReady(() => {
			this.setupDropdowns();
			this.setupFilterToggle();
			this.setupButtonFilterArrival();
		});
	}

	setupButtonFilterArrival() {
		const filterButton = document.getElementById('button-filter-arrival');
		const dropdownArrival = document.getElementById('dropdown-arrival');
		const dropdownArrivalContent = document.getElementById(
			'dropdown-arrival-content',
		);

		if (filterButton) {
			filterButton.addEventListener('click', () => {
				this.openFilters();
				this.openLayout();
				if (dropdownArrival && dropdownArrivalContent) {
					this.openDropdown(dropdownArrivalContent, dropdownArrival);
				}
			});
		}
	}

	setupDropdowns() {
		this.dropdownButtons = document.querySelectorAll(
			'.items-filter-dropdown-button',
		);
		this.dropdownContents = document.querySelectorAll(
			'.items-filter-dropdown-content',
		);

		this.dropdownButtons.forEach((button, index) => {
			button.addEventListener('click', event =>
				this.toggleDropdown(event, index),
			);
		});

		this.dropdownContents.forEach(content => {
			content.addEventListener('click', event => event.stopPropagation());
		});
	}

	setupFilterToggle() {
		const filterButtonToggle = document.getElementById(
			'app-filter-button-toggle',
		);
		if (filterButtonToggle) {
			filterButtonToggle.addEventListener('click', () =>
				this.toggleFilters(filterButtonToggle),
			);
		}
	}

	toggleDropdown(event, index) {
		const dropdownContent = this.dropdownContents[index];
		const isCurrentlyOpen = dropdownContent.classList.contains('open');

		if (!isCurrentlyOpen) {
			this.openDropdown(dropdownContent, event.currentTarget);
		} else {
			this.closeDropdown(dropdownContent, event.currentTarget);
		}

		event.stopPropagation();
	}

	openDropdown(dropdownContent, button) {
		dropdownContent.classList.add('open');
		button.setAttribute('aria-expanded', 'true');

		setTimeout(() => {
			const firstItem = dropdownContent.querySelector('li');
			if (firstItem) firstItem.focus();
		}, 0);
	}

	closeDropdown(dropdownContent, button) {
		dropdownContent.classList.remove('open');
		button.setAttribute('aria-expanded', 'false');
	}

	toggleFilters(button) {
		button.classList.toggle('open');
		const layout = document.getElementById('results-layout');
		if (layout) {
			layout.classList.toggle('filter-open');
		}
	}

	openFilters() {
		const button = document.getElementById('app-filter-button-toggle');
		if (button) {
			button.classList.add('open');
		}
	}
	closeFilters() {
		const button = document.getElementById('app-filter-button-toggle');
		if (button) {
			button.classList.remove('open');
		}
	}

	openLayout() {
		const layout = document.getElementById('results-layout');
		if (layout) {
			layout.classList.add('filter-open');
		}
	}
	closeLayout() {
		const layout = document.getElementById('results-layout');
		if (layout) {
			layout.classList.remove('filter-open');
		}
	}
}
